import Vue from 'vue'
import Router from 'vue-router'
import './components/Login.vue'
Vue.use(Router)

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,

    routes: [
        {
            path: '/',
            name: 'home',

            beforeEnter: (to, from, next) => {
                // ---------- case start
                switch (window.$cookies.get('RhSession').name) {
                    case "ADMIN":
                    case "jean":
                    case "admin":
                    case "agent":
                    case "anna":
                        next('/assistant')
                        break;
                    default:
                        next('/')
                }
                // ---------- case end
            }
        },
        {
            path: '/assistant',
            name: 'assistant',
            component: () => import('./components/exodus/assistant.vue'),
            beforeEnter: (to, from, next) => {
                switch (window.$cookies.get('RhSession').name) {
                    case "jean":
                    case "admin":
                    case "agent":
                    case "anna":
                        next()
                        break;
                    default:
                        next('/')
                }
                // ---------- case end
            }
        },
        {
            path: '/new',
            name: 'new',
            component: () => import('./components/empleados/new.vue'),
            beforeEnter: (to, from, next) => {
                switch (window.$cookies.get('RhSession').name) {
                    case "jean":
                    case "admin":
                        next()
                        break;
                    default:
                        next('/')
                }
                // ---------- case end
            }
        },
        // {
        //     path: '/rh',
        //     name: 'rh',
        //     component: () => import('./components/empleados/recursos_humanos.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "GERENTE":
        //             case "COORDINADOR_RH":
        //             case "COORDINADOR_OPERACIONES":
        //             case "RH":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/incidencias',
        //     name: 'incidencias',
        //     component: () => import('./components/empleados/incidencias.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "GERENTE":
        //             case "RH":
        //             case "COORDINADOR_OPERACIONES":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/citas',
        //     name: 'citas',
        //     component: () => import('./components/empleados/citas.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "COORDINADOR_RH":
        //             case "RH":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        {
            path: '/login',
            name: 'login',
            component: () => import('./components/Login.vue')
        },
        // {
        //     path: '/incidencias_lectura',
        //     name: 'incidencias_lectura',
        //     component: () => import('./components/empleados/incidencias_lectura.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "COORDINADOR_RH":
        //             case "RH":
        //             case "CONTABILIDAD":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/comidas',
        //     name: 'comidas',
        //     component: () => import('./components/empleados/comidas.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "RH":
        //             case "COORDINADOR_OPERACIONES":
        //             case "ASISTENTE_OPERACIONES":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/bajas',
        //     name: 'bajas',
        //     component: () => import('./components/empleados/bajas.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "RH":
        //             case "CONTABILIDAD":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/retardos_citas',
        //     name: 'retardos_citas',
        //     component: () => import('./components/empleados/retardos_citas.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "RH":
        //             case "ASISTENTE_OPERACIONES":
        //             case "COORDINADOR_OPERACIONES":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        {
            path: '/crear',
            name: 'crear',
            component: () => import('./components/requisicion/create.vue'),
            beforeEnter: (to, from, next) => {
                switch (window.$cookies.get('RhSession').rolName) {
                    case "ADMIN":
                    case "GERENTE":
                    case "RH":
                    case "COORDINADOR_OPERACIONES":
                    case "COORDINADOR_RH":
                        next()
                        break;
                    default:
                        next('/')
                }
            }
        },
        {
            path: '/finalizados',
            name: 'finalizados',
            component: () => import('./components/requisicion/ended.vue'),
            beforeEnter: (to, from, next) => {
                switch (window.$cookies.get('RhSession').rolName) {
                    case "ADMIN":
                    case "RH":
                    case "COORDINADOR_OPERACIONES":
                    case "COORDINADOR_RH":
                        next()
                        break;
                    default:
                        next('/')
                }
            }
        },
        {
            path: '/proceso',
            name: 'proceso',
            component: () => import('./components/requisicion/process.vue'),
            beforeEnter: (to, from, next) => {
                switch (window.$cookies.get('RhSession').rolName) {
                    case "ADMIN":
                    case "GERENTE":
                    case "RH":
                    case "COORDINADOR_OPERACIONES":
                    case "COORDINADOR_RH":
                        next()
                        break;
                    default:
                        next('/')
                }
            }
        },
        {
            path: '/ultimos',
            name: 'ultimos',
            component: () => import('./components/requisicion/request.vue'),
            beforeEnter: (to, from, next) => {
                switch (window.$cookies.get('RhSession').rolName) {
                    case "ADMIN":
                    case "RH":
                    case "COORDINADOR_OPERACIONES":
                    case "COORDINADOR_RH":
                        next()
                        break;
                    default:
                        next('/')
                }
            }
        },
        // {
        //     path: '/renovacion',
        //     name: 'renovacion',
        //     component: () => import('./components/empleados/renovacion.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "GERENTE":
        //             case "RH":
        //             case "COORDINADOR_OPERACIONES":
        //             case "COORDINADOR_RH":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/permisos',
        //     name: 'permisos',
        //     component: () => import('./components/empleados/permisos.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "RH":
        //             case "COORDINADOR_OPERACIONES":
        //             case "COORDINADOR_RH":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/incidencias_pagadora',
        //     name: 'incidencias_pagadora',
        //     component: () => import('./components/empleados/incidencias_pagadora.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "RH":
        //             case "COORDINADOR_RH":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/festivos',
        //     name: 'festivos',
        //     component: () => import('./components/empleados/festivos.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "RH":
        //             case "GERENTE":
        //             case "COORDINADOR_OPERACIONES":
        //             case "COORDINADOR_RH":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/descansos',
        //     name: 'descansos',
        //     component: () => import('./components/empleados/descansos.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "GERENTE":
        //             case "RH":
        //             case "COORDINADOR_OPERACIONES":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        // {
        //     path: '/contrato',
        //     name: 'contrato',
        //     component: () => import('./components/empleados/contrato.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "RH":
        //             case "COORDINADOR_OPERACIONES":
        //             case "COORDINADOR_RH":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // },
        {
            path: '/historial',
            name: 'historial',
            component: () => import('./components/requisicion/historial.vue'),
            beforeEnter: (to, from, next) => {
                if(window.$cookies.get('RhSession').rolName == 'ADMIN'){
                    next()
                }
            }
        },
        // {
        //     path: '/puestos',
        //     name: 'puestos',
        //     component: () => import('./components/empleados/puestos.vue'),
        //     beforeEnter: (to, from, next) => {
        //         switch (window.$cookies.get('RhSession').rolName) {
        //             case "ADMIN":
        //             case "GERENTE":
        //             case "RH":
        //             case "COORDINADOR_OPERACIONES":
        //             case "COORDINADOR_RH":
        //                 next()
        //                 break;
        //             default:
        //                 next('/')
        //         }
        //         // ---------- case end
        //     }
        // }
    ]
})
